import { Box } from '@mui/material';

export default function PercentageChip({ value, type }) {
	const style =
		type === 'margen' ? getMarginStyles(value) : getRoiStyles(value);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
			}}
		>
			<Box
				sx={{
					...style,
					borderRadius: '16px',
					padding: '0px 6px',
					height: '28px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				{value}%
			</Box>
		</Box>
	);
}

function getMarginStyles(percentageNumber) {
	return percentageNumber < 10
		? {
				backgroundColor: '#FED7AA',
				color: '#7C2512',
		  }
		: percentageNumber < 30
		? {
				backgroundColor: '#FDE68A',
				color: '#78350F',
		  }
		: {
				backgroundColor: '#A7F3D0',
				color: '#064E3B',
		  };
}

function getRoiStyles(percentageNumber) {
	return percentageNumber < 10
		? {
				backgroundColor: '#FED7AA',
				color: '#7C2512',
		  }
		: percentageNumber < 20
		? {
				backgroundColor: '#FDE68A',
				color: '#78350F',
		  }
		: {
				backgroundColor: '#A7F3D0',
				color: '#064E3B',
		  };
}
